import React, { FC, useCallback, useEffect, useState } from "react";
import IconButton from "../iconButton";
import { CopyLink } from "../../../../../../../components/icons";
import BaseCreateModal from "../baseCreateModal";
import { Button, Input, Space } from "antd";
import { useActions } from "../../../../../../../hooks/useActions";
import { useParams } from "react-router-dom";
import { I18n, Translate } from "react-redux-i18n";
import { getShortUrl } from "../../../distributionAndNotification/qrCodes/helpers";
import { copyToClipboard } from "../../../../../../../utils/copyToClipboard";
import { DistributionChannelTypeEnum } from "../../../../../../../types/DistributionChannel";

type Props = {
  readonly showButton?: boolean;
  readonly openModal?: boolean;
};

const CopyLinkButton: FC<Props> = (props) => {
  const { id: surveyId } = useParams();
  const { showButton = true, openModal = false } = props;
  const [modalOpen, setModalOpen] = useState(openModal);
  const [shortLink, setShortLink] = useState<string>("");
  const { setCurrentDistributionChannel } = useActions();

  useEffect(() => {
    if (surveyId) {
      getShortUrl(surveyId, "web", DistributionChannelTypeEnum.URL)
        .then(setShortLink)
        .catch(() => setShortLink(`${window._env_.WEB_SURVEY_BASE_URL}/${surveyId}?receiver=web&channel=URL`));
    }
  }, [surveyId]);

  const handleClick = useCallback(() => {
    setModalOpen(true);
  }, []);

  const handleCancel = useCallback(() => {
    setModalOpen(false);
    setCurrentDistributionChannel(undefined);
  }, [setCurrentDistributionChannel]);

  const handleCopy = useCallback(() => {
    copyToClipboard(shortLink);
    handleCancel();
  }, [shortLink, handleCancel]);

  return (
    <>
      {showButton && shortLink && <IconButton icon={<CopyLink />} label={"Web link"} onClick={handleClick} />}
      <BaseCreateModal
        title={I18n.t("linkToSurvey")}
        children={
          <Space.Compact style={{ margin: "24px 0", width: "100%" }}>
            <Input disabled value={shortLink} />
            <Button type="primary" onClick={handleCopy} disabled={!shortLink}>
              <Translate value={"copy"} />
            </Button>
          </Space.Compact>
        }
        onCancel={handleCancel}
        open={modalOpen}
        onSubmit={null}
      />
    </>
  );
};

export default CopyLinkButton;
